import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { permissionRepository } from '@webapp/platform/iam/data-access/repositories/PermissionRepository'

const base = ['report-access-grant']

export const reportAccessGrantQueryConfig = {
  /**
   * Without params, `list().queryKey` is the prefix matching every grants
   * list — for `invalidateQueries` only. Direct cache access must use the
   * FULL key (with the content-type id): `buildQueryKey` truncates at the
   * first `undefined`.
   */
  list: (params?: {
    secondaryCategoryId: number
    secondaryCategoryContentTypeId?: number
  }) => ({
    queryKey: buildQueryKey([
      ...base,
      'list',
      params?.secondaryCategoryId,
      params?.secondaryCategoryContentTypeId,
    ]),
    queryFn: () => {
      if (!params?.secondaryCategoryContentTypeId) {
        throw new Error(
          'Missing content type id for report access grants query'
        )
      }
      return permissionRepository.listReportAccessGrants({
        secondaryCategoryContentTypeId: params.secondaryCategoryContentTypeId,
        secondaryCategoryId: params.secondaryCategoryId,
      })
    },
  }),
}
